import useRoute from './useRoute';

export function useQuery<T extends any>(key: string) {
    const route = useRoute();
    return route.params?.[key] as T;
}

export function useQuerys<T extends { [key: string]: any }>() {
    const route = useRoute();
    return (route.params || {}) as T;
}
